import axios from 'axios';
const API_KEY = "c20644006c1a56f0c5eca8d53b6ccf4e";
export const getMoviesOrigional  = ({ commit }) => {
       axios.get(`https://api.themoviedb.org/3/trending/all/week?api_key=${API_KEY}&language=en-US`)
        .then(res => {
            commit('SET_MOVIESORIGIONAL' , res.data.results);
        })
    }